// MiniCalendar.jsx
import { Calendar } from 'lucide-react';

function isToday(date) {
  const today = new Date();
  return (
    date.getDate() === today.getDate() &&
    date.getMonth() === today.getMonth() &&
    date.getFullYear() === today.getFullYear()
  );
}

export default function MiniCalendar({ events = [] }) {
  // For demo, show current month
  const now = new Date();
  const year = now.getFullYear();
  const month = now.getMonth();
  const firstDay = new Date(year, month, 1);
  const lastDay = new Date(year, month + 1, 0);
  const dates = [];
  for (let d = 1; d <= lastDay.getDate(); d++) {
    dates.push(new Date(year, month, d));
  }
  // Map event dates for quick lookup
  const eventDates = Object.fromEntries(
    events.map(e => [new Date(e.startDate).toDateString(), true])
  );

  return (
    <div>
      <div className="flex items-center gap-2 mb-2">
        <Calendar className="h-5 w-5 text-indigo-400" />
        <span className="font-medium text-gray-800">Upcoming Time Off</span>
      </div>
      <div className="grid grid-cols-7 gap-1 mt-3">
        {['S', 'M', 'T', 'W', 'T', 'F', 'S'].map(day => (
          <div key={day} className="text-center text-xs font-medium text-gray-500 py-1">
            {day}
          </div>
        ))}
        {dates.map(date => (
          <div
            key={date.toString()}
            className={`h-8 flex items-center justify-center rounded-full text-sm ${
              eventDates[date.toDateString()]
                ? 'bg-indigo-100 text-indigo-700 font-medium'
                : 'text-gray-700'
            } ${isToday(date) ? 'ring-2 ring-indigo-500' : ''}`}
          >
            {date.getDate()}
          </div>
        ))}
      </div>
    </div>
  );
}
